import { FC } from "react";
import { NodeProps } from "reactflow";
import { StepDto, StepExecutionDto } from "../../../../../dtos";
import { PlayViewerNode } from "../../Components/PlayViewerNode";
import { CallMerge } from "@mui/icons-material";
import { MERGE_NODE_DESCRIPTION } from "../../utils";

export const MergePlayViewerNode: FC<NodeProps<StepDto | StepExecutionDto>> = (props) => {
    return <PlayViewerNode {...props} icon={<CallMerge fontSize='large' sx={{ transform: 'rotate(90deg)' }} />} description={MERGE_NODE_DESCRIPTION} disableEdit shape='diamond' disableViewExecutionDetails />;
}